import { Container, Grid } from '@mui/material';
import { FC, useCallback, useContext, useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { Button, ToastSeverity, theme, useToast } from 'thermia-react-container';
import { RegistrationsContext } from '../../context/contextProvider';
import useIsMounted from '../../hooks/useIsMounted';
import { ApiErrorHelper } from '../../validation/Errors';
import Wrapper from './containers/wrapper';

const CompletedRegistrations: FC = () => {
  const loading = useRef<boolean>(false);
  const isMounted = useIsMounted();
  const { t } = useTranslation('registrations');
  const { addToast } = useToast();
  const { registrations } = useContext(RegistrationsContext);
  const { fetchAllCompletedRegistrationsMetaData, isLoadingCompletedRegistrationsMetaData, completedRegistrationsMetaData, completedHasBeenFetched } = registrations;

  const handlefetchAllCompletedRegistrationsMetaData = useCallback(async () => {
    if(loading.current) {
      return;
    }
    loading.current = true;
    try {
      await fetchAllCompletedRegistrationsMetaData();
    } catch (e) {
      if (isMounted) {
        if (ApiErrorHelper.isOnsiteVersionInvalid(e)) {
          addToast(t('registrations.general.errorOnsiteVersionIsInvalid'), ToastSeverity.ERROR);
        } else {
          addToast(t('registrations.general.errorFetchRegistrations'), ToastSeverity.ERROR);
        }
      }
    } finally {
      loading.current = false;
    }
  }, [isMounted, fetchAllCompletedRegistrationsMetaData, addToast, t]);

  useEffect(() => {
    if (!completedHasBeenFetched) {
      handlefetchAllCompletedRegistrationsMetaData();
    }
  }, [completedHasBeenFetched, handlefetchAllCompletedRegistrationsMetaData]);

  return (
    <>
      <Container maxWidth="xl" sx={{ marginTop: theme.spacing(2), marginBottom: theme.spacing(50) }}>
        {completedRegistrationsMetaData && <Wrapper fetching={isLoadingCompletedRegistrationsMetaData} />}
        {!completedRegistrationsMetaData && (
          <Grid container justifyContent={'center'}>
            <Button
              variant="contained"
              style={{ backgroundColor: theme.palette.error.main }}
              title={`${t('registrations.general.errorFetchRegistrations')} - ${t('registrations.general.retry')}`}
              loading={isLoadingCompletedRegistrationsMetaData}
              onClick={handlefetchAllCompletedRegistrationsMetaData}
            />
          </Grid>
        )}
      </Container>
    </>
  );
};

export default CompletedRegistrations;
